import React from 'react';
import { DatoCmsMadLibsSectionComponent } from '../../../schema/datocms';
import { getColumnSpanClass, getColumnStartClass, getTextAlignmentClass, setSessionCookie } from '../../../utilities';
import { BhtpQuoteCta } from '../../quote-cta-component/quote-cta-component';
import { graphql, useStaticQuery } from 'gatsby';
import { AppConfig } from '../../../environment/app-config.model';
import HtmlStringComponent from '../../html-string/html-string-component';

export const CountriesStaticQuery = graphql`query CountriesStaticQuery {
    environment: environmentJson {
        bhtpConsumerGatewayBaseUrl
        bhtpQuoteRedirectUrl
    }
    allCountriesJson {
        nodes {
            countryIso2
            name
        }
    }
}`;

const MadLibsSectionComponent = (
    { columnLayout, title, titleAlignment, descriptionHtml, h1Title
    }: DatoCmsMadLibsSectionComponent
): React.ReactElement => {
    const { allCountriesJson, environment } = useStaticQuery<CountryStaticQueryResult>(CountriesStaticQuery);

    const config = {
        countryEligibilityUrl: `${environment.bhtpConsumerGatewayBaseUrl}eligibility/blocks/country/`,
        postalCodeValidationUrl: `${environment.bhtpConsumerGatewayBaseUrl}jurisdictions/city/postalcode/`,
        minFlightSegments: 1,
        maxFlightSegments: 10,
        maxTripLength: 364,
        minTripCost: 0,
        maxTripCost: 100000,
        maxTravelerAge: 125,
        minTravelers: 1,
        maxTravelers: 25,
        countries: allCountriesJson?.nodes || [],
        showPartnerAdvisorField: false
    };

    function submitted(data: any): void {
        if(data.detail) {
            const referringUrl = window.sessionStorage.getItem('quoteReferralUrl');
            if (referringUrl) {
                const pathData = {
                    name: 'quoteReferralPath',
                    value: referringUrl
                };
                data.detail.attributes ? data.detail.attributes.push(pathData) : data.detail.attributes = [pathData];
            }

            const urlSearch = window.localStorage.getItem('urlSearch');
            if (urlSearch) {
                const urlData = {
                    name: 'urlSearchParams',
                    value: urlSearch
                };
                data.detail.attributes ? data.detail.attributes.push(urlData) : data.detail.attributes = [urlData];
            }
        }

        setSessionCookie('quoteCtaInsuredEvent', JSON.stringify(data.detail));

        if (environment.bhtpQuoteRedirectUrl) {
            window.location.href = environment.bhtpQuoteRedirectUrl;
        }
    }

    const gridColumnSpanClass: string = getColumnSpanClass(columnLayout);
    const gridColumnStartClass: string = getColumnStartClass(columnLayout);

    return (
        <div className="theme-white page-component">
            <div className="container mx-auto lg:grid lg:grid-cols-12">
                <div className={`lg:${gridColumnSpanClass} lg:${gridColumnStartClass}`}>
                    { h1Title ? (
                        title && <h1 className={`${getTextAlignmentClass(titleAlignment)} mb-8`}>{title}</h1>
                    ) : (
                        title && <h2 className={`${getTextAlignmentClass(titleAlignment)} mb-8`}>{title}</h2>
                    )}
                    { descriptionHtml && <HtmlStringComponent className="mb-8" htmlString={descriptionHtml} /> }

                    <BhtpQuoteCta config={config} onCallToActionSubmitted={submitted} />
                </div>
            </div>
        </div>
    );
};

export default MadLibsSectionComponent;

interface CountryStaticQueryResult {
    allCountriesJson: { nodes: { countryIso2: string, name: string }[] };
    environment: Partial<AppConfig>;
}
